import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ScrollManager from './components/ScrollManager';
import SplashPage from './pages/SplashPage';
import Services from './pages/Services';
import FAQ from './pages/FAQ';
import Why from './pages/Why';
import HowWeWork from './pages/HowWeWork';
import Quiz from './pages/Quiz';

function App() {
  return (
    <div className="App">
      <ScrollManager />
      <Routes>
        <Route path="/" element={<SplashPage />} />
        <Route path="/services" element={<Services />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/why" element={<Why />} />
        <Route path="/how-we-work" element={<HowWeWork />} />
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/household" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;
